import {
  GET_PAYMENT_HASHED_FAILED,
  GET_PAYMENT_HASHED_REQUESTED,
  GET_PAYMENT_HASHED_SUCCESS,
  GET_PAYMENT_METHOD_FAILED,
  GET_PAYMENT_METHOD_REQUESTED,
  GET_PAYMENT_METHOD_SUCCESS,
  GET_PAYMENT_VERIFY_FAILED,
  GET_PAYMENT_VERIFY_REQUESTED,
  GET_PAYMENT_VERIFY_SUCCESS,
} from "resources/actionTypes";

const intialState = {
  userPaymentVerify: [],
  loading: false,
  error: null,
};
const intialHashState = {
  userPaymentHash: [],
  loading: false,
  error: null,
};
const intialPaymentState = {
  userPaymentMethod: [],
  loading: false,
  error: null,
};
export function userPaymentVerify(state = intialState, action) {
  switch (action.type) {
    case GET_PAYMENT_VERIFY_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_PAYMENT_VERIFY_SUCCESS:
      return {
        ...state,
        loading: false,
        userPaymentVerify: action.userPaymentVerify,
      };
    case GET_PAYMENT_VERIFY_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}
export function userPaymentHash(state = intialHashState,action){
  switch(action.type){
    case GET_PAYMENT_HASHED_REQUESTED:
      return {
        ...state,
        loading:true,
      };
    case GET_PAYMENT_HASHED_SUCCESS:
      return{
        ...state,
        loading:false,
        userPaymentHash:action.userPaymentHash,
      };
    case GET_PAYMENT_HASHED_FAILED:
      return {
        ...state,
        error: action.message,
      }
    default:
      return state;
  }
}

//Payment Method
export function userPaymentMethod(state = intialPaymentState,action){
  switch(action.type){
    case GET_PAYMENT_METHOD_REQUESTED:
      return {
        ...state,
        loading:true,
      };
    case GET_PAYMENT_METHOD_SUCCESS:
      return{
        ...state,
        loading:false,
        userPaymentMethod:action.userPaymentMethod,
      };
    case GET_PAYMENT_METHOD_FAILED:
      return {
        ...state,
        error: action.message,
      }
    default:
      return state;
  }
}